import { Api } from "@/plugins/api"

export default {
    state: {
        produits: [],
        panierDrawer: true,
        panier: [],
        totalPanier: {},
        caching: {
            once: true,
            loaded: false
        },
        loadingTotal: false,
        localStorageKey: 'DiabeteQuebec_Boutique_Panier'
    },
    getters: {
        produits(state) {
            return state.produits
        },
        panierDrawer(state) {
            return state.panierDrawer
        },
        panier(state) {
            return state.panier
        },
        total(state) {
            return state.totalPanier;
        },
        loadingTotal(state) {
            return state.loadingTotal;
        },
    },
    mutations: {
        SET_PRODUITS(state, data) {
            state.produits = data
        },
        SET_TOTALPANIER(state, data) {
            state.totalPanier = data
        },
        SHOW_PANIER(state) {
            state.panierDrawer = true
        },
        HIDE_PANIER(state) {
            state.panierDrawer = false
        },
        TOGGLE_PANIER(state) {
            state.panierDrawer = !state.panierDrawer
        },
        SET_PANIER_DRAWER(state, value) {
            state.panierDrawer = value
        }

    },
    actions: {
        LOAD_FROM_LOCAL_STORAGE({ dispatch, state }) {
            let panier = localStorage.getItem(state.localStorageKey)
            if (panier) {
                state.panier = JSON.parse(panier)
            }
            dispatch('FETCH_TOTAL')
        },
        ADD_ITEM({ dispatch, state }, item) {
            let foundIndex = state.panier.findIndex(p => p.id === item.id)
            if (foundIndex > -1) {
                state.panier[foundIndex].quantite++
            } else {
                state.panier.push({
                    ...item,
                    quantite: 1
                })
            }
            localStorage.setItem(state.localStorageKey, JSON.stringify(state.panier))
            dispatch('FETCH_TOTAL')
            state.panierDrawer = true
        },
        REMOVE_ITEM({ dispatch, state }, item) {
            let foundIndex = state.panier.findIndex(p => p.id === item.id)
            if (foundIndex > -1) {
                if (state.panier[foundIndex].quantite === 1) {
                    state.panier.splice(foundIndex, 1)
                } else {
                    state.panier[foundIndex].quantite--
                }
            }
            dispatch('FETCH_TOTAL')
            localStorage.setItem(state.localStorageKey, JSON.stringify(state.panier))
        },
        VIDER_PANIER({ dispatch, state }) {
            state.panier = []
            dispatch('FETCH_TOTAL')
            localStorage.setItem(state.localStorageKey, JSON.stringify(state.panier))
        },
        async FETCH_PRODUITS({ commit, state, rootGetters }) {
            if (state.caching.once && state.caching.loaded) {
                return;
            }
            let produits = await Api.get(`articles?typeContact=${rootGetters.typeContact}`);
            commit("SET_PRODUITS", produits.data);
            state.caching.loaded = true;
        },
        async FETCH_TOTAL({ commit, state, rootGetters }) {
            state.loadingTotal = true;
            let entree = { articles: state.panier, type: rootGetters.typeContact }

            let result = await Api.post(`boutiques/calcul`, entree);
            commit("SET_TOTALPANIER", result.data);
            state.loadingTotal = false
        }
    }
}